import React from "react";

const NotAllowedIcon = ({ cls }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_3386_53247)">
        <path
          d="M15.9995 0C12.835 0 9.74158 0.938384 7.11039 2.69649C4.47921 4.45459 2.42845 6.95345 1.21745 9.87707C0.0064443 12.8007 -0.310409 16.0177 0.306954 19.1214C0.924318 22.2251 2.44817 25.0761 4.68581 27.3137C6.92345 29.5514 9.77438 31.0752 12.8781 31.6926C15.9818 32.3099 19.1988 31.9931 22.1225 30.7821C25.0461 29.5711 27.5449 27.5203 29.303 24.8891C31.0611 22.2579 31.9995 19.1645 31.9995 16C31.9949 11.7579 30.3078 7.69095 27.3082 4.69136C24.3086 1.69177 20.2416 0.00458811 15.9995 0ZM15.9995 2.66667C19.0748 2.66421 22.0554 3.73033 24.4315 5.68267L5.68219 24.432C4.08294 22.4798 3.07106 20.1135 2.76434 17.6086C2.45762 15.1036 2.86866 12.5631 3.94963 10.2827C5.0306 8.00232 6.73703 6.07584 8.87029 4.72752C11.0035 3.37921 13.4759 2.66453 15.9995 2.66667ZM15.9995 29.3333C12.9242 29.3358 9.94362 28.2697 7.56752 26.3173L26.3169 7.568C27.9161 9.52022 28.928 11.8865 29.2347 14.3914C29.5414 16.8964 29.1304 19.4369 28.0494 21.7173C26.9684 23.9977 25.262 25.9242 23.1287 27.2725C20.9955 28.6208 18.5232 29.3355 15.9995 29.3333Z"
          fill="#ED3A3E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3386_53247">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotAllowedIcon;
